import { createTranslations } from '@npco/utils-translations'

export const cannotPayByCardTranslations = createTranslations({
  cantPayByCard:
    'Your ability to use your Zeller Card has been temporarily disabled. Please contact Zeller Support on {supportPhone} for more information.',
  editButton: 'Contact Us',
})
